import { OrderDirection } from "_shared/_api/ordering/order-direction";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { FeeScheduleTemplateOrderField } from "work/fee-schedule-templates/_api/queries/contracts/ordering/fee-schedule-template-order-field";
import { z } from "zod";

export type FeeScheduleTemplateOrderJSON = z.infer<typeof FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderJSONZ>;
export type FeeScheduleTemplateOrderProps = z.infer<
  typeof FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderZ
>;

export default class FeeScheduleTemplateOrderSchema {
  public static readonly FeeScheduleTemplateOrderJSONZ = z.object({
    orderBy: z.enum(FeeScheduleTemplateOrderField),
    orderDir: z.enum(OrderDirection),
  });
  public static readonly FeeScheduleTemplateOrderZ = z.object({
    orderBy: z.enum(FeeScheduleTemplateOrderField),
    orderDir: z.enum(OrderDirection),
  });

public static validateJSON(values: unknown): FeeScheduleTemplateOrderProps {
    return parseOrThrow(FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderZ, values, {
      logError: true,
      schemaName: "FeeScheduleTemplateOrderSchema",
      operation: "validateJSON",
      payloadSample: values,
    });
  }

  public static isValidJSON(values: unknown): values is FeeScheduleTemplateOrderProps {
    try {
      FeeScheduleTemplateOrderSchema.validateJSON(values);
      return true;
    } catch {
      return false;
    }
  }

  public static deserialize(data: FeeScheduleTemplateOrderJSON): FeeScheduleTemplateOrderProps {
    const parsed = parseOrThrow(FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderJSONZ, data, {
      logError: true,
      schemaName: "FeeScheduleTemplateOrderSchema",
      operation: "deserialize",
      payloadSample: data,
    });
    return FeeScheduleTemplateOrderSchema.codec.decode(parsed);
  }

  public static serialize(props: FeeScheduleTemplateOrderProps): FeeScheduleTemplateOrderJSON {
    const parsed = FeeScheduleTemplateOrderSchema.validateJSON(props);
    return FeeScheduleTemplateOrderSchema.codec.encode(parsed);
  }

  private static readonly codec = z.codec(FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderJSONZ, FeeScheduleTemplateOrderSchema.FeeScheduleTemplateOrderZ, {
    decode: (data) => ({
      orderBy: data.orderBy,
      orderDir: data.orderDir,
    }),
    encode: (template) => ({
      orderBy: template.orderBy,
      orderDir: template.orderDir,
    }),
  });
}
